/**
 * DevExtreme (esm/__internal/viz/core/themes/generic/light/sankey.js)
 * Version: 24.1.3
 * Build date: Tue Jun 11 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import { BLACK, CENTER, RIGHT, WHITE } from "./contants";
export default {
  sankey: {
    sourceField: "source",
    targetField: "target",
    weightField: "weight",
    hoverEnabled: true,
    alignment: CENTER,
    adaptiveLayout: {
      width: 80,
      height: 80,
      keepLabels: true
    },
    label: {
      visible: true,
      horizontalOffset: 8,
      verticalOffset: 0,
      overlappingBehavior: "ellipsis",
      useNodeColors: false,
      font: {
        color: BLACK,
        weight: 500
      },
      border: {
        visible: false,
        width: 2,
        color: WHITE
      },
      customizeText: info => info.title,
      shadow: {
        opacity: .2,
        offsetX: 0,
        offsetY: 1,
        blur: 1,
        color: WHITE
      }
    },
    title: {
      margin: 10,
      font: {
        size: 28,
        weight: 200
      },
      subtitle: {
        font: {
          size: 16
        }
      }
    },
    tooltip: {
      enabled: true
    },
    node: {
      padding: 30,
      width: 8,
      opacity: 1,
      border: {
        color: WHITE,
        width: 1,
        visible: false
      },
      hoverStyle: {
        hatching: {
          opacity: .75,
          step: 6,
          width: 2,
          direction: RIGHT
        },
        border: {}
      }
    },
    link: {
      color: "#888888",
      colorMode: "none",
      opacity: .3,
      border: {
        color: WHITE,
        width: 1,
        visible: false
      },
      hoverStyle: {
        opacity: .5,
        hatching: {
          opacity: .75,
          step: 6,
          width: 2,
          direction: RIGHT
        },
        border: {}
      }
    }
  }
};